var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "manufacturer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.634,
    height: 9.402,
    viewBox: "0 0 12.634 9.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_86252",
    "data-name": "Path 86252",
    d: "M.152,63.557H2.08a.152.152,0,0,0,.152-.152v-.582a.152.152,0,0,0-.152-.152H.152A.152.152,0,0,0,0,62.823v.582A.152.152,0,0,0,.152,63.557Z",
    transform: "translate(0 -62.671)",
    fill: "#86899b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86253",
    "data-name": "Path 86253",
    d: "M12.548,118.913a.19.19,0,0,0-.18-.015l-3.135,1.376v-1.2a.19.19,0,0,0-.266-.174l-3.135,1.377v-1.2a.19.19,0,0,0-.266-.174l-3.334,1.464v-2.321a.152.152,0,0,0-.152-.152H.152a.152.152,0,0,0-.152.152v7.466a.36.36,0,0,0,.36.36H12.444a.19.19,0,0,0,.19-.19v-6.606A.19.19,0,0,0,12.548,118.913Zm-8,4.655a.178.178,0,0,1-.178.178h-.86a.178.178,0,0,1-.178-.178v-1.424a.178.178,0,0,1,.178-.178h.86a.178.178,0,0,1,.178.178Zm3.4,0a.178.178,0,0,1-.178.178h-.86a.178.178,0,0,1-.178-.178v-1.424a.178.178,0,0,1,.178-.178h.86a.178.178,0,0,1,.178.178Zm3.4,0a.178.178,0,0,1-.178.178h-.86a.178.178,0,0,1-.178-.178v-1.424a.178.178,0,0,1,.178-.178h.86a.178.178,0,0,1,.178.178Z",
    transform: "translate(0 -116.466)",
    fill: "#86899b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturer);
export default __webpack_public_path__ + "static/media/manufacturer.b34352385c041a67ea1cd300539707dd.svg";
export { ForwardRef as ReactComponent };